export const name = '@lifi/sdk'
export const version = '3.0.0'
